var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class AssociationFly {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get association() {
        return this.parent;
    }
    get latestMouseMove() {
        return this.association.question.ownAspect.answer.aspectInteract.latest.mousemove;
    }
    get aspectMounted() {
        return this.association.question.ownAspect.answer.aspectMount;
    }
    get latestMouseX() {
        if (this.latestMouseMove) {
            return this.latestMouseMove.pageXInPixel;
        }
        return 20;
    }
    get latestMouseY() {
        if (this.latestMouseMove) {
            return this.latestMouseMove.pageYInPixel;
        }
        return 80;
    }
    get isFlyingToTargetPosition() {
        return this.association.isAssociationComplete; //  && this.association.ownAspect.associated.aspectMounted.areMeasurementsAvailable
    }
    get left() {
        if (this.isFlyingToTargetPosition) {
            return this.association.ownAspect.associated.aspectMount.measureToWindowIncludingTransform.aspectLeftInPixel;
        }
        return this.latestMouseX + 4;
    }
    get top() {
        if (this.isFlyingToTargetPosition) {
            return this.association.ownAspect.associated.aspectMount.measureToWindowIncludingTransform.aspectTopInPixel;
        }
        return this.latestMouseY + 4;
    }
    get transition() {
        if (this.association.isAssociationComplete)
            return 'transform 0.6s';
        return 'transform 0.03s';
    }
    get style() {
        const keepLatestMouseMoveObserved = this.latestMouseMove;
        return {
            position: 'absolute',
            transform: `translateX(${this.left}px) translateY(${this.top}px)`,
            left: 0,
            top: 0,
            transition: this.transition,
        };
    }
    get isHidden() {
        return false;
    }
}
__decorate([
    computed
], AssociationFly.prototype, "latestMouseX", null);
__decorate([
    computed
], AssociationFly.prototype, "latestMouseY", null);
__decorate([
    computed
], AssociationFly.prototype, "top", null);
__decorate([
    computed
], AssociationFly.prototype, "transition", null);
__decorate([
    computed.struct
], AssociationFly.prototype, "style", null);
